import { render, staticRenderFns } from "./AppTouchRail.vue?vue&type=template&id=6097065f&scoped=true&"
import script from "./AppTouchRail.vue?vue&type=script&lang=js&"
export * from "./AppTouchRail.vue?vue&type=script&lang=js&"
import style0 from "./AppTouchRail.vue?vue&type=style&index=0&id=6097065f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6097065f",
  null
  
)

export default component.exports